/**
 * @desc 包裹取消
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export type Response = defs.omsFlow.Response;
export function request(opNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/systemOrderPackage/cancel/${opNo}`, {
      method: "POST",

      ...options,
    }),
  );
}
